import { Component, OnInit } from '@angular/core';
import { Destroyable } from '../../../utils/mixins/destroyable.mixin';
import { HttpHeaders } from '@angular/common/http';
import { COMPONENT_ID_HEADER } from '../../../core/consts/api.const';
import { RockImagesService } from '../../../services/rock-images/rock-images.service';
import { LoadingService } from '../../../services/loading.service';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatListModule, MatListOption, MatSelectionListChange } from '@angular/material/list';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RockFile } from '../../../core/models/rock-files.model';
import { RemoveExtensionPipe } from '../../pipes/remove-extension.pipe';

@Component({
  selector: 'app-select-rock-file-popup',
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressSpinnerModule,
    RemoveExtensionPipe
  ],
  templateUrl: './select-rock-file-popup.component.html',
  styleUrl: './select-rock-file-popup.component.scss',
  standalone: true,
})
export class SelectRockFilePopupComponent extends Destroyable(Object) implements OnInit {
  readonly componentId: string = 'select-rock-images';
  isLoading: boolean = false;
  rockImageFiles: RockFile[] = [];
  filteredRockImageFiles: RockFile[] = [];
  selectedRockImageFile: RockFile | null = null;
  searchInput: string = '';

  constructor(
    public readonly dialogRef: MatDialogRef<SelectRockFilePopupComponent>,
    private readonly loadingService: LoadingService,
    private readonly rockImagesService: RockImagesService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribeToLoadingState();
    this.loadAvailableImages();
  }

  onSelect(): void {
    this.dialogRef.close(this.selectedRockImageFile);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onRowClick(file: RockFile): void {
    this.selectedRockImageFile =
      this.selectedRockImageFile?.fileName === file.fileName ? null : file;
  }

  filterRockImageFiles(): void {
    this.filteredRockImageFiles = this.rockImageFiles.filter((file) =>
      file.fileName.toLowerCase().includes(this.searchInput.toLowerCase()),
    );
  }

  onSelectionChange(event: MatSelectionListChange): void {
    const selectedOptions: MatListOption[] = event.source.selectedOptions.selected;

    if (selectedOptions.length === 0) {
      this.selectedRockImageFile = null;
    } else {
      this.selectedRockImageFile = selectedOptions[0].value;
    }
  }

  private loadAvailableImages(): void {
    this.loadingService.startLoading(this.componentId);

    const options = {
      headers: new HttpHeaders({
        [COMPONENT_ID_HEADER]: this.componentId,
      }),
    };

    this.rockImagesService
      .getRockFilesData(options)
      .pipe(this.takeUntilDestroyed())
      .subscribe((filenames: RockFile[]) => {
        this.rockImageFiles = [...filenames];
        this.filteredRockImageFiles = [...filenames];
      });
  }

  private subscribeToLoadingState(): void {
    this.loadingService
      .getLoadingState(this.componentId)
      .pipe(this.takeUntilDestroyed())
      .subscribe((loadingState: boolean) => {
        this.isLoading = loadingState;
      });
  }
}
